<template>
    <div class="land-around-cards" :class="'land-around-cards-' +  projectNameG">
        <div class="container">
            <div class="section-title">
                <h2>{{ salesCard.around_cards_section_title }}</h2>
            </div>
            <div class="around-cards">
                <div class="card" v-for="(item, index) in salesCard.around_cards" v-if="!isMobileChecker">
                    <strong v-html="item.title"></strong>
                    <div class="desc" v-html="item.desc"></div>
                    <div class="card-img" :style="'background-image: url(' + item.img + ')' "></div>
                </div>
                <div class="card-mobile" v-else>
                    <div class="card-img-mobile" v-if="index == 0">
                        <div class="pic-title-bg" :style="'background-image: url(' + item.img_mobile + ')' "></div>
                        <strong v-if="index == 0" :class="{'public-styles': projectNameG != 'duman'}" v-html="salesCard.around_cards_section_title"></strong>
                    </div>
                    <div class="card-img-mobile" :style="'background-image: url(' + item.img_mobile + ')' " v-if="index != 0"></div>
                    <div class="card-info">
                        <strong v-html="item.title"></strong>
                        <div class="desc" v-html="item.desc_mobile"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>   
</template>

<script>
    import {mapGetters} from 'vuex'
    export default {
        name: 'sale-land-around-cards',
        components: {
        },
        data () {
            return {
                projectNameG: window.host,
                lang: window.GlobalLang,
            }
        },
        computed: mapGetters({
            salesCard: 'loadSalesCardContent',
            isMobileChecker: 'loadIsMobileChecker',
        }),
        methods: {
        },
        beforeCreate() {
        },
        created () {
        },
        mounted () {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/sales/sales-land-partials/land-around-cards.scss';
    @import '@/styles/components/sales/respond/land-around-cards-respond.scss';
</style>